import { createSlice } from "@reduxjs/toolkit";
import { asyncStatus } from "../../utils/asyncStatus";
import {
  error_toast_message,
  success_toast_message,
} from "../../utils/toast_message";
import { getAppSettings, saveAppSettings } from "../../services/AppSettingsService";

const initialState = {
  // Get settings
  get_settings_status: asyncStatus.IDLE,
  settings: null,
  get_settings_error: null,

  // Save settings
  save_settings_status: asyncStatus.IDLE,
  save_settings_error: null,
};

const appSettingsSlice = createSlice({
  name: "appSettingsSlice",
  initialState,
  reducers: {
    resetSaveStatus: (state) => {
      state.save_settings_status = asyncStatus.IDLE;
      state.save_settings_error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Settings
    builder.addCase(getAppSettings.pending, (state) => {
      state.get_settings_status = asyncStatus.LOADING;
    });
    builder.addCase(getAppSettings.fulfilled, (state, { payload }) => {
      state.get_settings_status = asyncStatus.SUCCEEDED;
      state.settings = payload.settings || {};
    });
    builder.addCase(getAppSettings.rejected, (state, action) => {
      state.get_settings_status = asyncStatus.ERROR;
      state.get_settings_error = action.payload;
      error_toast_message(action.payload);
    });

    // Save Settings
    builder.addCase(saveAppSettings.pending, (state) => {
      state.save_settings_status = asyncStatus.LOADING;
    });
    builder.addCase(saveAppSettings.fulfilled, (state, { payload }) => {
      state.save_settings_status = asyncStatus.SUCCEEDED;
      state.settings = payload.settings || state.settings;
      success_toast_message(payload.message || "Settings saved successfully");
    });
    builder.addCase(saveAppSettings.rejected, (state, action) => {
      state.save_settings_status = asyncStatus.ERROR;
      state.save_settings_error = action.payload;
      error_toast_message(action.payload);
    });
  },
});

export const { resetSaveStatus } = appSettingsSlice.actions;

export default appSettingsSlice.reducer;
